import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.userEdit || initialState;

export const selectUserDetails = createSelector(
  [selectDomain],
  (state) => state.userDetails,
);

export const selectCompanyDetails = createSelector(
  [selectDomain],
  (state) => state.companyDetails
);

export const selectCompanyPickupAddress = createSelector(
  [selectDomain],
  (state) => state.companyPickupAddress
);

export const selectCompanyBillingAddress = createSelector(
  [selectDomain],
  (state) => state.companyBillingAddress
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectUpdatingUser = createSelector(
  [selectDomain],
  (state) => state.updatingUser
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);
